export default class CreateWorkScopeSpecificationError extends Error {
    
}